import {Image, Layout} from "antd";
import logoImg from "../../assets/logo.png";
import {ProductNameEnum} from "../../types/ProductNameEnum";

const appName = process.env.REACT_APP_NAME as ProductNameEnum;

const Header = () => {
    const {Header} = Layout;

    // QQPay
    const QQpay = () => {
        return <Header style={{color: "#fff"}}>{appName}</Header>;
    };

    const TKPay = () => {
        return <Header style={{color: "#fff"}}>{appName}</Header>;
    };

    const TGPay = () => {
        return <Header style={{color: "#fff", fontSize: "16px", fontWeight: "bold"}}>{appName}</Header>;
    };

    // KaroPay
    const KaroPay = () => {
        return (
            // <Header style={{background: "#E7DEF7", textAlign: "center"}}>
            //     <Image
            //         src={logoImg}
            //         preview={false}
            //         height={56}
            //     />
            // </Header>
            <div></div>
        );
    };
    return (
        <>
            {appName === ProductNameEnum.QQpay && <QQpay/>}
            {appName === ProductNameEnum.KaroPay && <KaroPay/>}
            {appName === ProductNameEnum.TKPay && <TKPay/>}
            {appName === ProductNameEnum.TGPay && <TGPay/>}
        </>
    );
};

export default Header;
